<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">地图列表</div>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="_UKey" label="地图Key"></el-table-column>
              <el-table-column
                prop="_Description"
                label="地图描述"
              ></el-table-column>
              <el-table-column
                label="图层"
                :formatter="getMapLayerNames"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="previewDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >预览</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <!-- <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >点位</el-button
                    > -->
                    <el-button
                      @click="deleteDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      v-if="scope.row._UKey != 'DefaultMap'"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <el-dialog
          class="emergencyoperations-dialog video-monitor"
          custom-class="bg3"
          top="20vh"
          :modal-append-to-body="false"
          :append-to-body="true"
          :visible.sync="isPreviewVisibale"
          :destroy-on-close="true"
        >
          <UMap :query="previewData"></UMap>
        </el-dialog>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../apis";
import UMap from "./components/UMap.vue";

export default {
  components: {
    UMap,
  },
  name: "MapAdmin",
  controller: "Home",
  action: "MapAdmin",
  data() {
    return {
      currentPage: 1,
      pageSize: 100,
      total: 0,
      tableData: [
        {
          _UKey: "",
          _UKeyName: "",
        },
      ],
      previewData: {
        syscode: "ZJMap",
        ukey: "DefaultMap",
      },
      isPreviewVisibale: false,
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      console.debug("search");
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        SysCode: "ZJMap",
      };
      new MyApis.UniformConfigApi()
        .GetConfigPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = this.extractMaps(r.PageContents);
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    extractMaps: function (confs) {
      var maps = [];
      if (confs && confs.length) {
        for (var i = 0, len = confs.length; i < len; i++) {
          var item = confs[i],
            uvalue;

          try {
            uvalue = eval("uvalue=" + item.UValue);
            item.UValue = uvalue;
          } catch (ex) {
            console.error(ex, item.UValue);
          }

          var map = item.UValue;
          if (map.UI && map.UI.type === "map") {
            map._SysCode = item.SysCode;
            map._UKey = item.UKey;
            map._UKeyName = item.UKeyName;
            map._Description = item.Description;
            map._Conf = item;
            maps.push(map);
          }
        }

        //按照 UKey 排序
        // eslint-disable-next-line no-undef
        QuickSort.sort(maps, function (a, b) {
          if (a._UKey == "DefaultMap") return -1;
          else if (b._UKey == "DefaultMap") return 1;
          if (a._UKey < b._UKey) return -1;
          else if (a._UKey > b._UKey) return 1;
          else return 0;
        });

        return maps;
      }
    },
    getMapLayerNames: function (row) {
      var lys = row.mapLayers;

      if (!lys) return "";

      if (typeof lys === "string") {
        return lys;
      }
      var arr = [];
      for (var i = 0; i < lys.length; i++) {
        var item = lys[i];
        if (typeof item === "string") arr.push(item);
        else arr.push(item.name);
      }
      return arr.join(",");
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/Map/Home/MapAdminEdit",
        //query: { syscode:"ZJMap", ukey:"DefaultMap", type: "add" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/Map/Home/MapAdminEdit",
        query: { syscode: row._SysCode, ukey: row._UKey, type: "edit" },
      });
    },
    //删除
    // eslint-disable-next-line no-unused-vars
    deleteDetail(index, row) {
      let searchInfo = {
        Id: row.Id,
        ConfigId: row.ConfigId,
        SysCode: row.SysCode,
        UKey: row.UKey,
      };
      new MyApis.UniformConfigApi()
        .DelConfig(searchInfo)
        .then((r) => {
          if (r && r.data && r.data.RspCode === "1") {
            this.$message({
              type: "success",
              message: "删除成功",
            });
          } else {
            console.log(r);
            this.$message({
              type: "success",
              message: r.data.RspMsg ? r.data.RspMsg : "删除失败！",
            });
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    //预览
    previewDetail(index, row) {
      this.previewData.syscode = row._SysCode;
      this.previewData.ukey = row._UKey;
      this.isPreviewVisibale = true;
    },
  },
};
</script>
